import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { Info } from '@mui/icons-material';

const InfoTooltip = ({
  title,
  placement = 'top',
  size = 'small',
  color = 'action',
  sx = {},
  iconSx = {},
  ...tooltipProps
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            lineHeight: 1.2,
            '& .MuiTooltip-tooltip': {
              lineHeight: 1.2,
            },
          },
        },
      }}
      {...tooltipProps}>
      <IconButton
        size={size}
        sx={{
          padding: '2px',
          marginLeft: '4px',
          color: `${color}.main`,
          ...sx,
        }}>
        <Info
          sx={{
            fontSize: size === 'small' ? '16px' : '20px',
            ...iconSx,
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
